export default {
  'status': 'Translation validated by country',
  'meta': {
    'lang': 'Português'
  },
  'title': 'QUICKDRAWS SIMOND ALPINISMO / RECOLHIMENTO DE PRODUTOS VERTIKA',
  'homepage': {
    'notice': 'Aviso de Recolhimento de Produto. Informações importantes sobre sua segurança e equipamento.',
    'purchaseWindow': 'Você adquiriu um mosquetão de escalada ALPINISM e/ou VERTIKA entre 1º de janeiro de 2022 e 23 de julho de 2026.',
    'skus': 'Mosquetão Alpinism 11 cm (4051175 / 8589547)\nMosquetão Alpinism 17 cm (4051176 / 8589548)\nPacote com 5 Mosquetões Alpinism (4171656 / 8608405)\nMosquetão Vertika 11 cm (5499689 / 8935765)\nMosquetão Vertika 17 cm (5500194 / 8935909)',
    'responsibility': 'O desenvolvimento de equipamentos de proteção individual implica total responsabilidade para com aqueles que utilizam nossos produtos. Portanto, informamos sobre o recolhimento do mosquetão equipado com o mosquetão Rocky Fil.',
    'defect': 'Identificamos um defeito na rebitagem da trava de segurança de alguns mosquetões. Esse defeito de montagem pode causar a quebra da trava de segurança e criar risco de ruptura do mosquetão em caso de queda.',
    'stopUsing': 'Como medida de precaução, solicitamos que pare imediatamente de usar o produto e siga o procedimento abaixo.'
  },
  'procedure': {
    'stopUsing': 'Portanto, solicitamos que interrompa imediatamente o uso deste equipamento e verifique se o seu produto apresenta este defeito seguindo as instruções de solução de problemas abaixo.',
    'title': 'Verifique seus produtos:',
    'intro': 'Verifique se ambos os lados da trava de arame permanecem firmemente presos ao mosquetão:',
    'step1': 'Segure o mosquetão por uma das extremidades, coloque o polegar entre os dois arames (o polegar mais próximo do rebite). Pressione firmemente para baixo contra o mosquetão.',
    'step2': 'Vire o mosquetão e repita a mesma ação do outro lado da trava de arame.'
  },
  'outcome': {
    'nok': {
      'body': 'Após inspeção, constatamos que o fio se soltou: Pare de usar o produto imediatamente e dirija-se à loja DECATHLON mais próxima. Lá, nossas equipes cuidarão do seu produto defeituoso e providenciarão o reembolso integral imediato para esses produtos recolhidos.',
      'support': 'Caso esteja enfrentando alguma dificuldade, nossa equipe de atendimento ao cliente está disponível para encontrar uma solução personalizada e orientá-lo em todas as etapas: 0800 710 770, de segunda a sábado, das 9h às 19h.'
    },
    'ok': {
      'body': 'Após verificação, o fio não se solta da sua estrutura: Seu produto não apresenta esse defeito e você pode continuar a usá-lo com total tranquilidade.'
    }
  },
  'buttons': {
    'ok': 'Meu produto está OK',
    'nok': 'Meu produto é NOK'
  }
} as const
